import type { SlDialog } from '@shoelace-style/shoelace';

import 'https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.0.0-beta.40/dist/components/icon/icon.js';
import 'https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.0.0-beta.40/dist/components/icon-button/icon-button.js';
import 'https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.0.0-beta.40/dist/components/dialog/dialog.js';

import { installRouter } from 'pwa-helpers/router';

import { Scroller } from './scroller';

import { registerIconLibrary } from 'https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.0.0-beta.40/dist/utilities/icon-library.js';

registerIconLibrary('default', {
  resolver: name => `https://cdn.jsdelivr.net/npm/bootstrap-icons@1.0.0/icons/${name}.svg`,
});

declare global {
  interface HTMLElementEventMap {
    'opened-changed': CustomEvent<{ value: boolean }>;
  }
}

function $<T = HTMLElement>(id: string): T {
  return document.getElementById(id) as unknown as T;
}

$('contact-dialog').addEventListener('opened-changed', ({ detail: { value: opened } }) =>
    (opened) ? null
  : history.pushState({ 'contact-dialog-opened': opened }, '', '/'));

$('print-button').addEventListener('click', () =>
  window.print());

WebComponents.waitFor(async function loadFonts() {
  if (document.fonts.ready)
    await document.fonts.ready;
  else
    await import('./load-fonts').then(m => m.loadFonts());

  document.body.removeAttribute('unresolved');
});

// Init the router
installRouter(function handleRoute(location: Location) {
  $<SlDialog>('contact-dialog').open = location.pathname.startsWith('/contact');
});

Scroller.initialize();

// Load pre-caching Service Worker
if ('serviceWorker' in navigator)
  navigator.serviceWorker.register('service-worker.js');
